import useRecordingStore from '../../api/recording/recordingStore';
import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { ReactComponent as SvgClose } from 'utils/app/assets/icons/Close.svg';

import './styles.css';
import { useSelectedLayout } from '../../../../../../../store/useSelectedLayout';
import { Device } from '../../../../../../../types/Device';

interface RecordingTimersProps {
    setIsStopModalVisible: (open: boolean) => void;
    setStopType: (type: 'audio' | 'video' | 'photo') => void;
    // setCurrentRecording: (recording: Recording) => void;
}

export const RecordingTimers = ({
    setIsStopModalVisible,
    setStopType,
    // setCurrentRecording,
}: RecordingTimersProps) => {
    const { selectedLayout } = useSelectedLayout();
    const [currentTime, setCurrentTime] = useState(Date.now());
    const { getDevicesWithRecording } = useRecordingStore();

    const recordingDevices = selectedLayout?.devices
        ? getDevicesWithRecording(selectedLayout?.devices)
        : [];

    // Группируем устройства по типу записи
    // const groupedByType = recordingDevices.reduce(
    //     (acc, device) => {
    //         const type = device.currentStatus?.includes('аудио') ? 'audio' : 'video';
    //         if (!acc[type]) {
    //             acc[type] = [];
    //         }
    //         acc[type].push(device);
    //         return acc;
    //     },
    //     {} as Record<'audio' | 'video', Device[]>,
    // );
    // const groupedByType = recordingDevices.reduce((acc, device) => {
    //     const type = device.currentStatus?.includes('аудио') ? 'audio' : 'video';
    //     acc[type] = (acc[type] || 0) + 1;
    //     return acc;
    // }, {} as Record<'audio' | 'video', number>);

    // Группируем количество по типу
    const recordingCounts = recordingDevices.reduce(
        (acc, device) => {
            const type = device.currentStatus?.includes('аудио') ? 'audio' : 'video';
            acc[type] = (acc[type] || 0) + 1;
            return acc;
        },
        {} as Record<'audio' | 'video', number>,
    );

    if (!selectedLayout || recordingDevices.length === 0) {
        return null;
    }

    // useEffect(() => {
    //     const timer = setInterval(() => {
    //         setCurrentTime(Date.now());
    //     }, 1000);
    //
    //     return () => clearInterval(timer);
    // }, []);

    const handlerStopClick = (type: 'audio' | 'video') => {
        setStopType(type);
        setIsStopModalVisible(true);
    };

    if (!selectedLayout) {
        return null;
    }
    return (
        // <div className="recording-timers">
        //     {filteredRecordings.map((recording, index) => {
        //         const date = new Date(recording.globalStartTime);
        //         const timezoneOffset = +5;
        //         const duration = currentTime - recording.globalStartTime;
        //         const hours = Math.floor(duration / (1000 * 60 * 60));
        //         const minutes = Math.floor((duration % (1000 * 60 * 60)) / (1000 * 60));
        //         const seconds = Math.floor((duration % (1000 * 60)) / 1000);
        //         date.setUTCHours(date.getUTCHours() + timezoneOffset);
        //         const formattedTime = date.toISOString().split('T')[1].slice(0, 8);
        //
        //         const devicesInCurrentLayout = recording.devices.filter((deviceEntry) =>
        //             selectedLayout?.devices?.some(
        //                 (device: Device) => device.UID === deviceEntry.device.UID,
        //             ),
        //         ).length;
        //
        //         return (
        //             <div key={recording.id} className="recording-timer">
        //                 <div className={'recording-timer-container'}>
        //                     <span
        //                         className={'headline medium'}
        //                         style={{ color: 'var(--gray-white)' }}
        //                     >
        //                         {String(hours).padStart(2, '0')}:{String(minutes).padStart(2, '0')}:
        //                         {String(seconds).padStart(2, '0')}
        //                     </span>
        //                     <span className={'body medium'} style={{ color: 'var(--gray-white)' }}>
        //                         {recording.type === 'audio' ? 'Запись аудио' : 'Запись видео'} (
        //                         {devicesInCurrentLayout})
        //                     </span>
        //                 </div>
        //                 <Button
        //                     className={
        //                         'button-base button-type-primary button-size-large button-state-danger'
        //                     }
        //                     onClick={() => handlerStopClick(recording)}
        //                 >
        //                     <SvgClose
        //                         style={{ fill: 'var(--gray-white)', position: 'relative', top: -1 }}
        //                     />
        //                     Закончить
        //                 </Button>
        //             </div>
        //         );
        //     })}
        // </div>
        // <div className="recording-timers">
        //     {Object.entries(groupedByType).map(([type, devices]) => {
        //         const devicesInCurrentLayout = devices.filter((device) =>
        //             selectedLayout?.devices?.some((d: Device) => d.UID === device.UID),
        //         ).length;
        //
        //         return (
        //             <div key={type} className="recording-timer">
        //                 <div className={'recording-timer-container'}>
        //                     <span
        //                         className={'headline medium'}
        //                         style={{ color: 'var(--gray-white)' }}
        //                     >
        //                         {type === 'audio' ? 'Запись аудио' : 'Запись видео'} (
        //                         {devicesInCurrentLayout})
        //                     </span>
        //                 </div>
        //                 <Button
        //                     className={
        //                         'button-base button-type-primary button-size-large button-state-danger'
        //                     }
        //                     onClick={() => handlerStopClick(type as 'audio' | 'video')}
        //                 >
        //                     <SvgClose
        //                         style={{ fill: 'var(--gray-white)', position: 'relative', top: -1 }}
        //                     />
        //                     Закончить
        //                 </Button>
        //             </div>
        //         );
        //     })}
        // </div>
        <div className="recording-timers">
            {Object.entries(recordingCounts).map(([type, count]) => (
                <div key={type} className="recording-timer">
                    <div className={'recording-timer-container'}>
                        <span className={'headline medium'} style={{ color: 'var(--gray-white)' }}>
                            {type === 'audio' ? 'Запись аудио' : 'Запись видео'} ({count})
                        </span>
                    </div>
                    <Button
                        className={
                            'button-base button-type-primary button-size-large button-state-danger'
                        }
                        onClick={() => {
                            setStopType(type as 'audio' | 'video');
                            setIsStopModalVisible(true);
                        }}
                    >
                        <SvgClose
                            style={{ fill: 'var(--gray-white)', position: 'relative', top: -1 }}
                        />
                        Закончить
                    </Button>
                </div>
            ))}
        </div>
    );
};
